/** Aliquota IVA standard arredamento (Davide 2026-05-22: 22% su tutto). */
export const IVA_RATE = 0.22;

/** Formatta un importo in euro con locale italiano (1.234,50 €). */
export function formatEuro(value: number): string {
  return new Intl.NumberFormat("it-IT", {
    style: "currency",
    currency: "EUR",
  }).format(value);
}
